import { render, staticRenderFns } from "./FormDialogs.vue?vue&type=template&id=04208b92&"
import script from "./FormDialogs.vue?vue&type=script&lang=js&"
export * from "./FormDialogs.vue?vue&type=script&lang=js&"
import style0 from "./FormDialogs.vue?vue&type=style&index=0&id=04208b92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports